import { Component } from '@angular/core';
import { FormControl, FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { nav_path } from 'src/app/app-routing.module';
import { AuthService } from 'src/app/core/services/auth.service';
import { ConsoleLoggerService } from 'src/app/core/services/console-logger.service';
import { SeoService } from '../../../../core/services/seo.service';

@Component({
  selector: 'anon-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {
  public forgotPasswordForm = new FormGroup({
    email: new FormControl<string>(
      '', {nonNullable: true, validators: [Validators.required, Validators.email]}
    )
  });
  public nav_path = nav_path;
  private title = "Forgot password page"

  constructor(
    public authService: AuthService,
    private fb: UntypedFormBuilder,
    private cLog: ConsoleLoggerService,
    private seo: SeoService
  ) {
    seo.generateTags({
      title: this.title,
      description: `Anonymous Systems ${this.title}`,
      route: nav_path.forgotPassword
    });
  }

  get email() { return this.forgotPasswordForm.controls.email; }

  onSubmit() {
    const email = this.email.value;
    this.authService.sendPasswordResetEmail(email)
      .then(res => {
        if (res === 'success') this.cLog.info(`successfully sent password reset email to: '${email}'`)
      });
  }
}
